import Vue from 'vue'
import { Input } from 'ant-design-vue'
import { savePreviousData } from '@/services/api'

Vue.use(Input)

export default Vue.extend({
  template: `
    <div class="a-gcell" v-if="editorShow">
      <a-input
        size="small"
        v-model="value"
        @focus="savePreviousData(value)"
        @keydown.tab="saveData"
        @keydown.enter="saveData"
        @blur="saveData"
        ref="txt-input"
        :autoFocus="true"
        :maxLength="100"
      />
    </div>
    <div class="a-gcell" v-else>
      -
    </div>
    `,

  data() {
    return {
      value: null,
      loading: false,
      editorShow: true,
      savePreviousData: savePreviousData,
      keyCode: undefined,
    }
  },
  created() {
    this.value = this.params.value
    this.keyCode = undefined
    if (
      this.params.colDef.field === 'quantity_Percentage' &&
      this.params.data['unit'] !== 'SF'
    ) {
      this.editorShow = false
    } else {
      this.editorShow = true
    }
  },
  methods: {
    saveData(event) {
      this.value = event.target.value
      if (!this.keyCode) {
        this.keyCode = event.keyCode
        switch (this.params.colDef.cellRendererParams.type) {
          case 'dynamicTable':
            this.$root.$emit(
              'handleChange',
              event.target.value,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              null,
              null,
              event.keyCode,
            )
            break
          case 'analysisSheet':
            this.$root.$emit(
              'saveAnalysisData',
              event.target.value,
              this.params.data,
              this.params.colDef.field,
              this.params.data.columnId,
              null,
              null,
              event.keyCode,
            )
            break
          case 'tenants':
            this.$root.$emit(
              'saveTenantData',
              this.params.colDef.field,
              event.target.value,
              this.params.colDef.headerName,
              this.params.data,
              event.keyCode,
            )
            break
          case 'projectTenants':
            this.$root.$emit(
              `saveTenantData${this.params.data.assetId}`,
              this.params.colDef.field,
              event.target.value,
              this.params.colDef.headerName,
              this.params.data,
              event.keyCode,
            )
            break
          case 'projectDetails':
            this.$root.$emit(
              'updateAssetsDetails',
              event.target.value,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              null,
              event.keyCode,
            )
            break
          default:
            break
        }
      }
    },

    getValue() {
      return this.value
    },
  },
})
